import i18n from '../locales/index'
import util from '@/utils/util';

/**
 * @description 將數字轉換成K為單位的字符
 * @param {Number} val
 * @returns {String}
 * 23 => 23
 * 1122 => 1.1K
 */
export function thousandsTranslate(val = 0) {
  if (!/^\d+$/.test(val)) return val;
  if (val < 1000) return val;

  let th = Math.floor(val / 1000) * 100;
  let decimal = Math.round((val % 1000) / 10);

  return (th + decimal) / 100 + 'K';
}

/**
 * @description 滿贈信息
 */
export function parseGiveAway({ startNum, giftNum }) {
  return i18n.t('filters_index_56', [startNum,giftNum]);
}

/**
 * @description 技能類名
 */
export function gameCategory(type) {
  switch (type) {
    case 'Game':
      return i18n.t('filters_index_57');
    case 'Fun':
      return i18n.t('filters_index_58');
    case 'Communication':
      return i18n.t('filters_index_59');
    case 'Other':
      return i18n.t('filters_index_60');
    default:
      return '';
  }
}

export function parseGameMode(code) {
  const rs = util.gameModelColumn.find(item => item.value === code);
  return rs ? rs.text : code;
}

/**
 * @description 將訂單狀態轉換稱業務文案，首字母小寫
 * @param {String} status 訂單狀態
 * @param {String} prefix 是否將Finished狀態轉換稱Complete文案
 * @returns {String}
 */
export function orderProgressStatusTranslate(
  status,
  preStatus = '',
  prefix = 'You'
) {
  if (!status) return status;

  if (status === 'Processing' && preStatus === 'Effective') {
    return (
      prefix +
      (prefix === 'You' ? ' accepted the order' : ' accepted your order')
    );
  }

  if (status === 'Invalid' && preStatus === 'Effective') {
    return prefix + ' canceled the order';
  }

  // if (status === '')

  let map = {
    Effective: 'placed the order',
    Processing: 'accepted your order',
    Arbitrated: 'dispute resolved',
    Controversy: 'cancellation request',
    Negotiate: 'in dispute',
    Arbitration: 'in dispute',
    Finished: prefix ? 'completed' : 'write a review',
    Invalid: 'canceled',
    completed: 'completed'
  };

  return map[status] || status;
}

export function parseNum(num, length = 0) {
  num = Number(num);
  const multiple = Math.pow(10, length);
  return (parseInt(num * multiple) / multiple).toFixed(length);
}

/**
 * @description 將訂單狀態轉換稱業務文案，首字母大寫
 * @param {String} status 訂單狀態
 * @param {Boolean} finishedToComplete 是否將Finished狀態轉換稱Complete文案
 * @returns {String}
 */
export function orderStatusTranslateUpperCase(status, type, refundType) {
  if (!status) return status;
  let map = {
    Created: i18n.t('filters_index_61'),
    Effective: i18n.t('filters_index_62'),
    Processing: i18n.t('filters_index_63'),
    Controversy: i18n.t('filters_index_64'),
    Negotiate: type === 'c' ? i18n.t('filters_index_168') : i18n.t('filters_index_65'),
    Arbitration: type === 'c' ? i18n.t('filters_index_168') : i18n.t('filters_index_65'),
    Arbitrating: type === 'c' ? i18n.t('filters_index_168') : i18n.t('filters_index_65'),
    Arbitrated: type === 'c' ? i18n.t('filters_index_168') : i18n.t('filters_index_65'),
    Finished: i18n.t('filters_index_66'),
    Invalid: refundType === 'FULL' ? i18n.t('filters_index_169') : i18n.t('filters_index_67'),
    Completed: i18n.t('filters_index_68'),
    PlayerConfirm: i18n.t('filters_index_69'),
    REFUND_SUCCESS: refundType === 'FULL' ? i18n.t('filters_index_170') : i18n.t('filters_index_70')
  };

  return map[status] || status;
}

export function salesUnitTranslate(salesUnit, hack = false) {
  if (!salesUnit) return salesUnit;
  const map = {
    HalfHour: i18n.t('filters_index_71'),
    Hour: i18n.t('filters_index_72'),
    Game: i18n.t('filters_index_73'),
    h: i18n.t('filters_index_72'),
    Time: i18n.t('filters_index_74'),
    win: i18n.t('filters_index_75'),
    Day: i18n.t('filters_index_76'),
    Minutes7: i18n.t('filters_index_77')
  };
  return (
    (hack ? (salesUnit !== 'HalfHour' ? 1 : '') : '') + map[salesUnit] ||
    salesUnit
  );
}

// 訂單信息
export function orderInfoTranslate(
  info,
  controler = [
    'gameName',
    'gameModelName',
    'gameQuickMatchLevels',
    'sex',
    'budgetAmountRight',
    'experience'
  ]
) {
  const {
    gameName,
    gameModelName,
    gameQuickMatchLevels,
    sex,
    currencyKind,
    budgetAmountRight,
    salesUnit,
    count,
    extraInfo
  } = info;
  let result = [];
  if (gameName && controler.includes('gameName')) {
    result.push(gameName);
  }
  if (extraInfo) {
    const extraJson = JSON.parse(extraInfo);
    if (extraJson) {
      const { currentSelectTime } = extraJson;
      if (currentSelectTime) {
        result.push(currentSelectTime);
      }
    }
  }
  if (gameModelName && controler.includes('gameModelName')) {
    result.push(gameModelName === i18n.t('filters_index_78') ? i18n.t('filters_index_171') : gameModelName);
  }
  if (gameQuickMatchLevels && controler.includes('gameQuickMatchLevels')) {
    result.push(
      gameQuickMatchLevels === i18n.t('filters_index_78') ? i18n.t('filters_index_172') : gameQuickMatchLevels
    );
  }
  if (sex && controler.includes('sex')) {
    const filter = {
      Male: i18n.t('filters_index_79'),
      Female: i18n.t('filters_index_80')
    };
    result.push(filter[sex] || i18n.t('filters_index_81'));
  }
  if (controler.includes('experience') && info.experience) {
    result.push(i18n.t('filters_index_82'));
    return result.join('，');
  }
  if (budgetAmountRight && controler.includes('budgetAmountRight')) {
    let str = '';
    if (+budgetAmountRight === 999999) {
      str += i18n.t('filters_index_83');
    } else {
      str += ` ${'$' || currencyKind}${budgetAmountRight}/`;
    }
    str += `${salesUnitTranslate(salesUnit)}*${count}`;
    result.push(str);
  }
  return result.join('，');
}

// 四捨五入保留一位小數
export function RoundingFilter(value) {
  if (!value) return value;
  return parseFloat(value).toFixed(1);
}

/**
 * @param {string} format 格式
 * @param {int} timestamp 要格式化的時間 預設為當前時間
 * @return {string}   格式化的時間字符串
 */
export function tuiFormartDate(mss) {
  // var days = parseInt(mss / (1000 * 60 * 60 * 24));
  var hours = parseInt(mss / (1000 * 60 * 60));
  var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
  return hours + i18n.t('filters_index_72') + minutes + i18n.t('filters_index_84');
}

/**
 * @description 退款申請詳情 將訂單狀態轉換稱業務文案
 * @param {String} status 訂單狀態
 * @returns {String}
 */
export function tuiCorderStatus(status) {
  if (!status) return status;

  const map = {
    Controversy: i18n.t('filters_index_85'),
    Negotiate:
      i18n.t('filters_index_86')
  };

  return map[status] || status;
}
/**
 * @description 退款詳情 將拒絕信息轉換稱業務文案
 * @param {String} rejectReason 拒絕原因
 * @returns {String}
 */
export function tuiRejectReason(rejectReason) {
  if (!rejectReason) return rejectReason;
  const reasonList = {
    COMPLETED: i18n.t('filters_index_87'),
    USER_MALICIOUS_REFUND: i18n.t('filters_index_88'),
    OTHER: i18n.t('filters_index_89')
  };
  return reasonList[rejectReason] || rejectReason;
}

/**
 * @description: 用戶等級文案
 * @param {*}
 * @return {*}
 */
export function getUserlevel(level) {
  if (!level) return i18n.t('filters_index_90');
  if (level < 6) return i18n.t('filters_index_91');
  if (level < 11) return i18n.t('filters_index_92');
  if (level < 13) return i18n.t('filters_index_93');
  if (level > 12) return i18n.t('filters_index_94');
}

/**
 * @description: 用戶等級顏色
 * @param {*}
 * @return {*}
 */
export function getUserlevelColor(level) {
  if (!level) return '#535C65';
  if (level < 6) return '#B2853E';
  if (level < 11) return '#8456C9';
  if (level > 10) return '#68243A';
}
/**
 * @description: 用戶權益
 * @param {*}
 * @return {*}
 */
export function getUserPrivilege(currentCard) {
  if (currentCard == 0) {
    return [
      {
        level: 1,
        levelName: 'VIP1',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: '',
            src:
              'https://resource.funplus.social/user-static/cc35f6d8-3228-48a8-a6c6-9796070b3adf1123446027332737724.png'
          }
        ],
        contents: []
      },
      {
        level: 2,
        levelName: 'VIP2',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: '',
            src:
              'https://resource.funplus.social/user-static/42876e1c-5a13-4932-b6c1-e66e153cccde3917384102538674185.png'
          }
        ],
        contents: []
      },
      {
        level: 3,
        levelName: 'VIP3',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: '',
            src:
              'https://resource.funplus.social/user-static/3ffe4926-5d69-41c6-8e6d-049f6cd78de83388470595401218205.png'
          }
        ],
        contents: []
      },
      {
        level: 4,
        levelName: 'VIP4',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/d6ccfc1b-234d-4324-91c0-8c54c743b3458870321603918141904.png'
          },
          {
            title: i18n.t('filters_index_97'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers10.png')
          }
        ],
        contents: [i18n.t('filters_index_99')]
      },
      {
        level: 5,
        levelName: 'VIP5',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/561d1cc8-06c3-4a12-a20b-738e9912cad26747758172681581216.png'
          },
          {
            title: i18n.t('filters_index_100'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers15.png')
          }
        ],
        contents: [i18n.t('filters_index_101')]
      }
    ];
  }
  if (currentCard == 1) {
    return [
      {
        level: 6,
        levelName: 'VIP6',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/55f5ae32-51d2-4051-bc80-7c4b8ebb8cfd8265352842262970098.png'
          },
          {
            title: i18n.t('filters_index_102'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers202.png')
          }
        ],
        contents: [i18n.t('filters_index_103')]
      },
      {
        level: 7,
        levelName: 'VIP7',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/09e62b3f-516a-49ae-86ad-bff7241fa8301879889190588913679.png'
          },
          {
            title: i18n.t('filters_index_104'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers205.png')
          }
        ],
        contents: [i18n.t('filters_index_105')]
      },
      {
        level: 8,
        levelName: 'VIP8',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/78c7680b-4e52-4d29-8d46-4790a2d1db04826041686437768312.png'
          },
          {
            title: i18n.t('filters_index_106'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers405.png')
          },
          {
            title: i18n.t('filters_index_107'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/7ad23dcd-6e89-4d5f-8b3b-19c93504399162458071860111974.webp'
          }
        ],
        contents: [i18n.t('filters_index_108')]
      },
      {
        level: 9,
        levelName: 'VIP9',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/1473103e-04e9-4d28-8a7b-6cbea07a09335872199161878626306.png'
          },
          {
            title: i18n.t('filters_index_109'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers506.png')
          },
          {
            title: i18n.t('filters_index_110'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_112'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/1ab0e7e5-4c88-44e1-b145-6f0b476a97765043400655333806831.webp'
          },
          {
            title: i18n.t('filters_index_113'),
            remark: i18n.t('filters_index_114'),
            src: 'https://resource.funplus.social/sys-feed/vip10mount.png'
          }
        ],
        contents: [i18n.t('filters_index_115')]
      },
      {
        level: 10,
        levelName: 'VIP10',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/7ae5ea64-bd0e-4581-9aff-c043a8a005055301247670341822606.png'
          },
          {
            title: i18n.t('filters_index_116'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers5010.png')
          },
          {
            title: i18n.t('filters_index_117'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_118'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/e55a0ad8-cc3d-4c25-ab61-701a0db0506b2942692824599419797.webp'
          },
          {
            title: i18n.t('filters_index_119'),
            remark: i18n.t('filters_index_114'),
            src:
              'https://resource.3uplay.com/user-static/b5fcd9fa-037a-4413-9302-22fd334671ad829868178297944366.png'
          },
          {
            title: i18n.t('filters_index_120'),
            remark: i18n.t('filters_index_121'),
            src:
              'https://resource.funplus.social/user-static/ce027ebd-d55c-4d9c-83fa-d0864e1c76244602803198104592251.png'
          }
        ],
        contents: [i18n.t('filters_index_122')]
      }
    ];
  }
  if (currentCard == 2) {
    return [
      {
        level: 11,
        levelName: 'VIP11',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/45a4eb82-a223-4a95-abc0-744f27d16b475713656407318892648.png'
          },
          {
            title: i18n.t('filters_index_123'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers10010.png')
          },
          {
            title: i18n.t('filters_index_124'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_125'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/f380bbc0-7524-4ef1-997b-22147514aa4a8681103701677371083.webp'
          },
          {
            title: i18n.t('filters_index_126'),
            remark: i18n.t('filters_index_114'),
            src:
              'https://resource.3uplay.com/user-static/528a63f8-aa6e-4e61-a9a4-a2b71cb321474313932241586712510.png'
          },
          {
            title: i18n.t('filters_index_127'),
            remark: i18n.t('filters_index_128'),
            src:
              'https://resource.funplus.social/user-static/d5ed48b4-22b7-4889-ad23-e87531663d3b215121112193972884.png'
          }
        ],
        contents: [i18n.t('filters_index_129')]
      },
      {
        level: 12,
        levelName: 'VIP12',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/cdc30821-3913-42a7-a468-564cf1c026da6295698306921076813.png'
          },
          {
            title: i18n.t('filters_index_130'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers15010.png')
          },
          {
            title: i18n.t('filters_index_131'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_132'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/48014152-7173-4e8b-9ed0-dcf80b4603167898124707431348557.webp'
          },
          {
            title: i18n.t('filters_index_133'),
            remark: i18n.t('filters_index_114'),
            src:
              'https://resource.3uplay.com/user-static/d2ff59d0-70d8-480a-9e63-1c17774817e4339078782096881481.png'
          },
          {
            title: i18n.t('filters_index_134'),
            remark: i18n.t('filters_index_135'),
            src:
              'https://resource.3uplay.com/user-static/cda5c90c-d4a1-4646-8348-ff54219b812f6783784607361150213.png'
          },
          {
            title: i18n.t('filters_index_136'),
            remark: i18n.t('filters_index_137'),
            src:
              'https://resource.funplus.social/sys-feed/cbf45522-9c6c-4ec5-b6db-a9701bf844924779238591151154335.webp'
          }
        ],
        contents: [i18n.t('filters_index_138')]
      }
    ];
  }
  if (currentCard == 3) {
    return [
      {
        level: 13,
        levelName: 'VIP13',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/2fbe29ac-23c4-4d9f-a76a-fc634ea59ade2103908576236737035.png'
          },
          {
            title: i18n.t('filters_index_139'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers20010.png')
          },
          {
            title: i18n.t('filters_index_140'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_141'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/54594ada-50ab-4c50-aec3-73442f8569d26998679258403359771.webp'
          },
          {
            title: i18n.t('filters_index_142'),
            remark: i18n.t('filters_index_114'),
            src:
              'https://resource.funplus.social/user-static/5599e8fc-91c8-4929-b72a-fdc6d65e099c2211960911304977854.png'
          },
          {
            title: i18n.t('filters_index_143'),
            remark: i18n.t('filters_index_144'),
            src:
              'https://resource.3uplay.com/user-static/d442c7a3-9c45-42e0-afc1-973ab87be0e69012342766309652403.png'
          },
          {
            title: i18n.t('filters_index_145'),
            remark: i18n.t('filters_index_146'),
            src:
              'https://resource.funplus.social/sys-feed/746410f7-2887-4ce6-b7bb-fc95bf46abaa4026451898564482081.webp'
          },
          {
            title: i18n.t('filters_index_147'),
            remark: '',
            src:
              'https://resource.funplus.social/icon/beautiful-account-uuid.png'
          },
          {
            title: i18n.t('filters_index_148'),
            remark: '',
            src: 'https://resource.funplus.social/icon/exclusive-headframe.png'
          }
        ],
        contents: [
          i18n.t('filters_index_149')
          // '每日可主動取消10次極速約單',
          // '可指定陪玩師上推薦特權5次'
        ]
      },
      {
        level: 14,
        levelName: 'VIP14',
        list: [
          {
            title: i18n.t('filters_index_95'),
            remark: i18n.t('filters_index_96'),
            src:
              'https://resource.funplus.social/user-static/43d58099-d952-4136-a0f6-2ca6c88994051962669988220948509.png'
          },
          {
            title: i18n.t('filters_index_139'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers20010.png')
          },
          {
            title: i18n.t('filters_index_150'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_151'),
            remark: '',
            src:
              'https://resource.3uplay.com/sys-feed/72b8b495-5b20-486d-87db-85c788bc623d4618690156184238774.webp'
          },
          {
            title: i18n.t('filters_index_152'),
            remark: i18n.t('filters_index_114'),
            src:
              'https://resource.3uplay.com/user-static/c8c6b450-f4f7-48a0-8f77-2bfe39a6d0633647890664831876505.png'
          },
          {
            title: i18n.t('filters_index_153'),
            remark: i18n.t('filters_index_154'),
            src:
              'https://resource.3uplay.com/user-static/32b54587-3132-4fe2-b395-dc0bec0033eb3991062369174230640.png'
          },
          {
            title: i18n.t('filters_index_155'),
            remark: i18n.t('filters_index_156'),
            src:
              'https://resource.funplus.social/sys-feed/b05854d9-e91a-46f8-a6dd-9ccbad30dc4f7397840883905391607.webp'
          },
          {
            title: i18n.t('filters_index_157'),
            remark: '',
            src:
              'https://resource.funplus.social/icon/beautiful-account-uuid.png'
          },
          {
            title: i18n.t('filters_index_158'),
            remark: '',
            src: 'https://resource.funplus.social/icon/exclusive-title.jpg'
          }
        ],
        contents: [i18n.t('filters_index_159')]
      },
      {
        level: 15,
        levelName: 'VIP15',
        list: [
          // {
          //   title: '會員專屬裝扮（永久）',
          //   remark: '等級專屬頭像框、聊天氣泡、進場橫幅',
          //   src: ''
          // },
          {
            title: i18n.t('filters_index_139'),
            remark: i18n.t('filters_index_98'),
            src: require('@/upgrade-page/views/vip-center/images/vouchers20010.png')
          },
          {
            title: i18n.t('filters_index_160'),
            remark: i18n.t('filters_index_111'),
            src: require('@/assets/image/icons/diamond.png')
          },
          {
            title: i18n.t('filters_index_161'),
            remark: '',
            src:
              'https://resource.funplus.social/sys-feed/2e9fb8f7-4afb-4392-a734-b51f884da9077328833523230148633.webp'
          },
          {
            title: i18n.t('filters_index_162'),
            remark: i18n.t('filters_index_163'),
            src:
              'https://resource.funplus.social/user-static/155f1f37-b1c7-45dc-ac5f-7ccd6d722af81325340255550521669.png'
          },
          {
            title: i18n.t('filters_index_164'),
            remark: i18n.t('filters_index_163'),
            src:
              'https://resource.funplus.social/user-static/63c74b27-5672-48ec-b900-927b700de8db3983784119880237444.png'
          },
          {
            title: i18n.t('filters_index_165'),
            remark: '',
            src:
              'https://resource.funplus.social/icon/beautiful-account-uuid.png'
          },
          {
            title: i18n.t('filters_index_166'),
            remark: '',
            src: 'https://resource.funplus.social/icon/exclusive-pendant.png'
          }
        ],
        contents: [i18n.t('filters_index_167')]
      }
    ];
  }
}
